import { LoanDetailAction } from '../types/LoanDetailAction';

export const LoanStatusChangeActions = [
  LoanDetailAction.CANCEL,
  LoanDetailAction.CANCEL_TEST,
  LoanDetailAction.DESIST,
  LoanDetailAction.FORMALIZE_APPLICATION,
  LoanDetailAction.MARK_LOAN_AS_PAID,
];
